import { LocationType } from '@cmctechnology/webinvest-store-frontend';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { subscribeProfitLoss, unsubscribeProfitLoss } from './profitLossActions';
import { IStore, ACCOUNT_STORE_NAME } from './store';
import { AccountKey } from './types';

export const useSubscribeProfitLoss = (location: LocationType, accountNo: AccountKey) => {
  const dispatch = useDispatch();
  const accountProfitLoss = useSelector((store: IStore) => store[ACCOUNT_STORE_NAME].profitLoss[accountNo]);
  const [prevAccountNo, setPrevAccountNo] = useState<AccountKey>(accountNo);

  useEffect(() => {
    dispatch<any>(subscribeProfitLoss(location, accountNo));
    return () => {
      dispatch<any>(unsubscribeProfitLoss(location, accountNo));
    };
  }, []);

  useEffect(() => {
    if (accountNo === prevAccountNo) return;

    dispatch<any>(unsubscribeProfitLoss(location, prevAccountNo));
    dispatch<any>(subscribeProfitLoss(location, accountNo));
    setPrevAccountNo(accountNo);

    return () => {
      dispatch<any>(unsubscribeProfitLoss(location, accountNo));
    };
  }, [accountNo]);

  return {
    data: accountProfitLoss
  };
};
